<osn-cxb-table-view [dataSource]="pages" [dragAndDrop]="false" [data-testid]="testId">
  <ng-template
    let-internalName
    [osnTableViewCellProperty]="getProperty('pageName')"
    osnTableViewCellTitle="Page name"
    [osnTableViewCellSortable]="false"
  >
    <p data-testid="page-list-item-internal-name">{{ internalName }}</p>
  </ng-template>

  <ng-template
    *ngIf="showAttachedGenre"
    let-attachedGenre
    [osnTableViewCellProperty]="getProperty('attachedGenre')"
    osnTableViewCellTitle="Attached genre"
    [osnTableViewCellSortable]="false"
  >
    <p>{{ attachedGenre }}</p>
  </ng-template>

  <ng-template
    *ngIf="showType"
    let-type
    [osnTableViewCellProperty]="getProperty('displayedType')"
    osnTableViewCellTitle="Type"
    [osnTableViewCellSortable]="false"
  >
    <p>{{ type }}</p>
  </ng-template>

  <ng-template
    *ngIf="showTargeting"
    let-countries
    [osnTableViewCellProperty]="getProperty('countries')"
    osnTableViewCellTitle="Countries"
    [osnTableViewCellSortable]="false"
  >
    <ng-container
      *ngTemplateOutlet="targetingTemplate; context: { $implicit: countries, userSegmentOrCountries: 'Country' }"
    ></ng-container>
  </ng-template>

  <ng-template
    *ngIf="showTargeting"
    let-userSegments
    [osnTableViewCellProperty]="getProperty('userSegments')"
    osnTableViewCellTitle="User segments"
    [osnTableViewCellSortable]="false"
  >
    <ng-container
      *ngTemplateOutlet="targetingTemplate; context: { $implicit: userSegments, userSegmentOrCountries: 'UserSegment' }"
    ></ng-container>
  </ng-template>

  <ng-template
    let-date
    [osnTableViewCellProperty]="getProperty('lastPublished')"
    osnTableViewCellTitle="Last published"
    [osnTableViewCellSortable]="false"
  >
    <p *ngIf="date">{{ date | date: 'dd/MM/yyyy, HH:mm z' }}</p>
    <p *ngIf="!date" class="text-normal-bold">
      Unpublished
      <span class="warning-icon-wrapper">
        <svg-icon key="warning" class="inline-icon" size="sm"></svg-icon>
      </span></p
  ></ng-template>

  <ng-template
    let-status
    [osnTableViewCellProperty]="getProperty('status')"
    osnTableViewCellTitle="Status"
    [osnTableViewCellSortable]="false"
  >
    <ng-container [ngSwitch]="status">
      <div *ngSwitchCase="PageStatus.LIVE_ONLY">
        <p><i class="ok-sign"></i> Live</p>
      </div>
      <div *ngSwitchCase="PageStatus.DRAFT_AND_LIVE">
        <p>
          <i class="ok-sign"></i> Live
          <span class="text-normal-bold">
            <span class="warning-icon-wrapper ml-3">
              <svg-icon key="warning" size="sm" class="inline-icon"></svg-icon>
            </span>
            Draft</span
          >
        </p>
      </div>
      <div *ngSwitchCase="PageStatus.DRAFT_ONLY">
        <p class="text-normal-bold">
          <span class="warning-icon-wrapper">
            <svg-icon key="warning" size="sm" class="inline-icon"></svg-icon>
          </span>
          Draft
        </p>
      </div>
    </ng-container>
  </ng-template>

  <ng-template
    let-row="row"
    [osnTableViewCellProperty]="getProperty('targetPageId')"
    [osnTableViewCellSortable]="false"
    osnTableViewCellWidth="7.5%"
  >
    <div *ngIf="castRow(row) as row" class="row-end-center">
      <a
        *ngIf="row.status !== PageStatus.DRAFT_ONLY && row.livePageUrl && accesses.screen.launcherScreen.edit && tenantSpecificActions?.isPageViewIconEnabled"
        [href]="row.livePageUrl"
        target="_blank"
        class="row-start-center mr-3 view-button"
      >
        <svg-icon key="eye" class="mr-2"></svg-icon>
        View
      </a>

      <a [routerLink]="[row.pageType.routePath, row.targetPageId]" class="edit-column text-normal-bold" data-testid="page-edit-button">
        <svg-icon key="edit" class="mr-2"></svg-icon>
        Edit
      </a>
    </div>
  </ng-template>
</osn-cxb-table-view>
<div *ngIf="isLoading" class="d-flex justify-content-center">Loading...</div>

<div *ngIf="!pages.length && !isLoading" class="d-flex justify-content-center">No results found.</div>

<ng-template #targetingTemplate let-values let-userSegmentOrCountries="userSegmentOrCountries">
  <ng-container *ngIf="values | pageListTargetingTooltip: userSegmentOrCountries | async as tooltipAndDisplayedText">
    <span
      class="tooltip-content"
      [matTooltip]="tooltipAndDisplayedText.tooltip"
      matTooltipPosition="above"
      matTooltipClass="custom-tooltip"
    >
      {{ tooltipAndDisplayedText.displayedText }}
    </span>
  </ng-container>
</ng-template>
